import {getInfo, login, register, logout} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'

const user = {
    state: {
        token: getToken(),
        id: '',
        name: '',
        email: '',
        isAdmin: false,
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_ID: (state, id) => {
            state.id = id
            // 判断是否为管理员（ID为1，支持数字和字符串类型）
            state.isAdmin = id === 1 || id === '1'
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_EMAIL: (state, email) => {
            state.email = email
        },
        SET_PRIVATE_KEY: (state, privateKey) => {
            state.privateKey = privateKey
        },
    },

    actions: {
        // 登录
        Login({commit}, userInfo) {
            const account = userInfo.account.trim()
            const password = userInfo.password.trim()
            return new Promise((resolve, reject) => {
                login(account, password).then((res) => {
                    setToken(res.data.token)
                    commit('SET_TOKEN', res.data.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 注册
        Register(context, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password.trim()
            const email = userInfo.email.trim()
            return new Promise((resolve, reject) => {
                register(username, password, email).then(() => {
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({commit}) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    const user = res.data
                    commit('SET_ID', user.id)
                    commit('SET_NAME', user.username)
                    commit('SET_EMAIL', user.email)
                    commit('SET_PRIVATE_KEY', user.secretKey)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 退出系统
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        },

        // 更新用户邮箱
        updateUserEmail({commit}, newEmail) {
            commit('SET_EMAIL', newEmail)
        }
    }
}

export default user
